"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icons_1 = require("../icons");
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
function Tag(_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.filled, filled = _c === void 0 ? false : _c, color = _a.color, _d = _a.closable, closable = _d === void 0 ? false : _d, onClose = _a.onClose, className = _a.className, style = _a.style, children = _a.children, rootHtmlProps = _a.rootHtmlProps;
    var prefix = ConfigProvider_1.usePrefix('tag');
    var sizeCls = utils_1.concat(prefix, size);
    var classname = classnames_1.default(prefix, className, sizeCls, color && utils_1.concat(prefix, 'color', color), filled && utils_1.concat(prefix, 'filled'), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var styleObj = tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style);
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: classname, style: styleObj }),
        react_1.default.createElement("div", { className: utils_1.concat(prefix, 'text') }, children),
        closable && react_1.default.createElement(icons_1.CloseIcon, { className: utils_1.concat(prefix, 'close'), onClick: onClose })));
}
exports.Tag = Tag;
//# sourceMappingURL=index.js.map